import { render, staticRenderFns } from "./VirtualStationItem.vue?vue&type=template&id=499cf7e6&scoped=true"
import script from "./VirtualStationItem.vue?vue&type=script&lang=js"
export * from "./VirtualStationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499cf7e6",
  null
  
)

export default component.exports